import React from 'react';
import { Flex, Box, Image, Text } from 'rebass';

import iconCheck from '../../assets/images/icon-check.svg';

const Checkpoint = ({ content }) => (
  <Flex my={2}>
    <Box minWidth={'12px'}>
      <Image src={iconCheck}></Image>
    </Box>
    <Box pl={3}>
      <Text fontSize={1} fontFamily="lato">
        {content}
      </Text>
    </Box>
  </Flex>
);

export default Checkpoint;
